module.exports = __webpack_public_path__ + "img/06.c1a95f73.svg";